import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";

import LoadingSpinner from "core/LoadingSpinner";
import InitializePhotoUploads from "../PhotoUploadCore/InitializePhotoUploads";

import {
    useExistingUploads,
    usePhotoUploadRedirect
} from "../PhotoUploadCore/hooks";
import { usePhotoUpload } from "frontend/hooks/usePhotoUpload";

import PhotoUploadProviders from "../PhotoUploadCore/PhotoUploadProviders";

const PhotoUploadViewUnwrapped = () => {
    const { setCurrentPhotoShootId } = usePhotoUpload();

    useEffect(() => {
        setCurrentPhotoShootId(null);
    }, []);

    const [redirect, setRedirect] = useState(null);

    const location = useLocation();

    const {
        hasExistingUploadBatch,
        batchDataLoaded,
        existingUploads,
        hasExistingPhotoShoot,
        shootDataLoaded,
        existingUploadsDataLoaded,
        withdrawnUploadsData,
        withdrawnUploads
    } = useExistingUploads();

    const {
        RedirectToTypeSelectPage,
        RedirectToIndividualUploadPage,
        RedirectToPhotoShootUploadPage
    } = usePhotoUploadRedirect(location);

    useEffect(() => {
        if (
            !batchDataLoaded ||
            !shootDataLoaded ||
            !withdrawnUploadsData ||
            !existingUploadsDataLoaded
        )
            return;

        if (!hasExistingUploadBatch) {
            if (!hasExistingPhotoShoot) {
                return setRedirect(<RedirectToTypeSelectPage />);
            } else {
                return setRedirect(<RedirectToPhotoShootUploadPage />);
            }
        }

        if (!!existingUploads.length) {
            const { photoShoot } = existingUploads[0];

            if (photoShoot.isForSinglePhoto) {
                return setRedirect(<RedirectToIndividualUploadPage />);
            } else {
                return setRedirect(<RedirectToPhotoShootUploadPage />);
            }
        }

        if (withdrawnUploads.length) {
            const { photoShoot } = withdrawnUploads[0];

            if (photoShoot.isForSinglePhoto) {
                return setRedirect(<RedirectToIndividualUploadPage />);
            } else {
                return setRedirect(<RedirectToPhotoShootUploadPage />);
            }
        }

        return setRedirect(<RedirectToTypeSelectPage />);
    }, [
        batchDataLoaded,
        existingUploads,
        hasExistingPhotoShoot,
        shootDataLoaded,
        withdrawnUploadsData,
        existingUploadsDataLoaded
    ]);

    // wait to load upload batches
    if (!redirect) return <LoadingSpinner />;

    return redirect;
};

const PhotoUploadView = () => (
    <PhotoUploadProviders>
        <InitializePhotoUploads>
            <PhotoUploadViewUnwrapped />
        </InitializePhotoUploads>
    </PhotoUploadProviders>
);

export default PhotoUploadView;
